// Device Information (Bluetooth SIG service 0x180A): the maker and model a
// rower or bike reports about itself, saved with each session so its numbers
// are only compared on the same machine (api/lib/machines.js).
//
// Optional all the way: the service must be in requestDevice()'s
// optionalServices for Chrome to allow it, so gear paired before this asks
// again only when it's paired again, and plenty of machines don't have it.

export const DEVICE_INFORMATION_UUID = 0x180a;
const MANUFACTURER_NAME_UUID = 0x2a29;
const MODEL_NUMBER_UUID = 0x2a24;

/** A characteristic's UTF-8 string, without the padding some machines add. */
export const decodeText = (view) => {
  if (!view) return null;
  const bytes = new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
  const text = new TextDecoder("utf-8").decode(bytes).replace(/\0/g, "").trim();
  return text || null;
};

/** { manufacturer?, model? } from a connected GATT server; {} when it says nothing. */
export async function readDeviceInfo(server) {
  const out = {};
  let service;
  try {
    service = await server.getPrimaryService(DEVICE_INFORMATION_UUID);
  } catch {
    return out;
  }
  for (const [key, uuid] of [
    ["manufacturer", MANUFACTURER_NAME_UUID],
    ["model", MODEL_NUMBER_UUID],
  ]) {
    try {
      const value = decodeText(await (await service.getCharacteristic(uuid)).readValue());
      if (value) out[key] = value;
    } catch {
      /* not every machine has both */
    }
  }
  return out;
}

/**
 * The machines used in a workout, by type, for the session's
 * telemetry_summary.machines: each connected rower or bike that recorded
 * anything this workout. Null when none did.
 */
export const machinesUsed = (devices) => {
  const out = {};
  for (const d of devices || []) {
    const machine = d?.summaryRef?.current?.machine;
    if (machine && (d.type === "rower" || d.type === "indoor_bike") && !out[d.type]) out[d.type] = machine;
  }
  return Object.keys(out).length ? out : null;
};
